export default "__VITE_ASSET__GSS9kLoH__"